<template>
  <div>
    <back />
    <div class="det">
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="订单编号:">
                  <div> {{ ruleForm.orderCode }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单状态:">
                  <div v-if="ruleForm.status == 0" style="color: red;">待到店</div>
                  <div v-if="ruleForm.status == 1">已完成</div>
                  <div v-if="ruleForm.status == 2">已失效</div>
                  <div v-if="ruleForm.status == 3">已取消</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="预约时间:">
                  <div>{{ `${ruleForm.reservationTime}` || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="预计到店时间:">
                  <div>{{ `${ruleForm.reservationTime} ${ruleForm.startHour}-${ruleForm.endHour}` || '--' }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="核销时间:" v-if="ruleForm.status == 1">
                  <div>{{ ruleForm.checkTime }}</div>
                </el-form-item>
                <el-form-item label="失效时间:" v-if="ruleForm.status == 2">
                  <div>{{ ruleForm.invalidTime || '--' }}</div>
                </el-form-item>
                <el-form-item label="取消时间:" v-if="ruleForm.status == 3">
                  <div>{{ ruleForm.cancelTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>

        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="用户名称：">
                  <div>{{ ruleForm.userName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="联系电话：">
                  <div>{{ ruleForm.userTel }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 课程信息 -->
      <div class="top">
        <div class="title">项目信息：</div>
        <el-form :model="ruleForm" ref="classRuleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="项目名称：">
                  <div>{{ ruleForm.projectName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="项目分类：">
                  <div>{{ ruleForm.categoryName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="项目时长：">
                  <div>{{ `${ruleForm.durationMinute} 分钟` }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="项目部位：">
                  <div>{{ ruleForm.serviceLocation }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="服务内容：">
                <el-image v-if="ruleForm.processPic" style="width: 150px; height: 150px" :src="ruleForm.processPic"
                  :preview-src-list="[ruleForm.processPic]" fit="cover">
                </el-image>
                <div v-else>--</div>
              </el-form-item>
            </el-col>
            <!-- <div class="g_table">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column label="序号" width="180" align="center">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
</el-table-column>
<el-table-column prop="processName" label="内容" align="center">
</el-table-column>
<el-table-column prop="durationMinute" label="时长(分钟)" width="180" align="center">
</el-table-column>
</el-table>
</div> -->
          </el-row>
        </el-form>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},//订单信息
      tableData: []//服务内容
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    // 修改请求当前信息
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.reserveOrderInfo, {
        params: {
          id: this.$route.query.id,//订单id
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.tableData = result.processList || []//服务内容
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },

  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }
  }


}
</style>